import type { ComponentProps } from 'react';
import { OwcTabs } from '@one/react';

export type PocTabsProps = ComponentProps<typeof OwcTabs>;

export const PocTabs: React.FC<PocTabsProps> = (props) => <OwcTabs {...props} />;
